import simg from '@images/services/icon_01.svg';
import simg2 from '@images/services/icon_02.svg';
import simg3 from '@images/services/icon_03.svg';


import sSimg1 from '@images/service-single/img-1.webp';
import sSimg2 from '@images/service-single/img-2.webp';
import sSimg3 from '@images/service-single/img-3.webp';

import sSingleimg1 from '@images/service-single/2.webp';
import sSingleimg2 from '@images/service-single/3.webp';

import FloorsServiceContent from './Floors';
import StairsServiceContent from './Stairs';
import ServicesServiceContent from './Services';
import React from 'react';

const Services = {
    pl: [
        {
            Id: 'podłogi',
            sImg: simg,
            sSimg: sSimg1,
            sTitle: 'Podłogi drewniane',
            slug: 'podlogi-drewniane',
            description: 'Produkcja i montaż podłóg drewnianych, parkietów, parkietów przemysłowych oraz listew wykończeniowych',
            des2: 'Elementum aliquam byuerirra sagittis duis non quis.',
            des3: 'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
            ssImg1: sSingleimg1,
            ssImg2: sSingleimg2,
            content: <FloorsServiceContent sTitle='Podłogi drewniane'/>,
        },
        {
            Id: 'schody',
            sImg: simg2,
            sSimg: sSimg2,
            sTitle: 'Schody drewniane',
            slug: 'schody-drewniane',
            description: 'Produkcja i montaż schodów drewnianych, schodów jednobiegowych, dwubiegowych, łamanych, wachlarzowych, zabiegowych',
            des2: 'Elementum aliquam byuerirra sagittis duis non quis.',
            des3: 'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
            ssImg1: sSingleimg1,
            ssImg2: sSingleimg2,
            content: <StairsServiceContent sTitle='Schody drewniane'/>,
        },
        {
            Id: 'serwis',
            sImg: simg3,
            sSimg: sSimg3,
            sTitle: 'Serwis podłóg i parkietów',
            slug: 'serwis-podlog-i-parkietow',
            description: 'Profesjonalne cyklinowanie, lakierowanie, olejowanie, bejcowanie, konserwacja, reperacje zniszczonych podłóg, parkietów i schodów.',
            des2: 'Elementum aliquam byuerirra sagittis duis non quis.',
            des3: 'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
            ssImg1: sSingleimg1,
            ssImg2: sSingleimg2,
            content: <ServicesServiceContent sTitle='Serwis podłóg i parkietów'/>,
        },
    ],
    en: [
        {
            Id: 'floors',
            sImg: simg,
            sSimg: sSimg1,
            sTitle: 'Wooden Floors',
            slug: 'wooden-floors',
            description: 'Production and installation of wooden floors, parquet, industrial parquet, and finishing strips',
            des2: 'Elementum aliquam byuerirra sagittis duis non quis.',
            des3: 'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
            ssImg1: sSingleimg1,
            ssImg2: sSingleimg2,
            content: <FloorsServiceContent sTitle='Wooden Floors'/>,
        },
        {
            Id: 'stairs',
            sImg: simg2,
            sSimg: sSimg2,
            sTitle: 'Wooden Stairs',
            slug: 'wooden-stairs',
            description: 'Production and installation of wooden stairs, single-flight, double-flight, broken, fan-shaped, and winder stairs',
            des2: 'Elementum aliquam byuerirra sagittis duis non quis.',
            des3: 'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
            ssImg1: sSingleimg1,
            ssImg2: sSingleimg2,
            content: <StairsServiceContent sTitle='Wooden Stairs'/>,
        },
        {
            Id: 'service',
            sImg: simg3,
            sSimg: sSimg3,
            sTitle: 'Floor and Parquet Service',
            slug: 'floor-and-parquet-service',
            description: 'Professional sanding, varnishing, oiling, staining, maintenance, and repair of damaged floors, parquet, and stairs.',
            des2: 'Elementum aliquam byuerirra sagittis duis non quis.',
            des3: 'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
            ssImg1: sSingleimg1,
            ssImg2: sSingleimg2,
            content: <ServicesServiceContent sTitle='Floor and Parquet Service'/>,
        },
    ],
};

export default Services;
